
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/ai-assistant",
      function () {
        return require("private-next-pages/clm/ai-assistant/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/ai-assistant"])
      });
    }
  